<template>
  <div class="ml-3 relative">
    <button
      @click="showDropdown = !showDropdown"
      class="flex items-center text-sm border-2 border-transparent rounded-full focus:outline-none focus:border-gray-300 transition duration-150 ease-in-out"
      id="user-menu"
      aria-label="User menu"
      aria-haspopup="true"
    >
      <avatar :user-display="userDisplay" />
    </button>
    <transition
      enter-active-class="ease-out duration-300"
      enter-class="opacity-0 scale-90"
      enter-to-class="opacity-100 scale-100"
      leave-active-class="ease-in duration-200"
      leave-class="opacity-100 scale-100"
      leave-to-class="opacity-0 scale-90"
    >
      <div
        class="z-10 origin-top-right absolute right-0 mt-2 w-64 rounded-md shadow-lg"
        v-show="showDropdown"
      >
        <div class="py-1 rounded-md bg-white shadow-xs" v-if="loggedIn">
          <a
            @click="signOut"
            href="#"
            class="block px-4 py-2 text-lg leading-5 text-gray-700 font-open-sans  tracking-wide
            hover:text-red focus:outline-none  transition duration-150 ease-in-out"
            >Sign out</a
          >

          <div
            class="px-4 py-2 text-lg leading-5 text-gray-700 font-open-sans tracking-wide break-words flex flex-col"
          >
            <div>Display Name</div>
            <div class="font-semibold">{{ userDisplay }}</div>
          </div>

          <div
            class="px-4 py-2 text-lg leading-5 text-gray-700 font-open-sans tracking-wide break-words flex flex-col"
          >
            <div>Email</div>
            <div class="font-semibold">{{ email }}</div>
          </div>

          <!--          if we need this option for normal users, just uncomment this block-->
          <!--          <div class="px-4 py-2">-->
          <!--            <router-link to="/updateDisplayName" class="flex items-center">-->
          <!--              <a-->
          <!--                href="#"-->
          <!--                class="block text-lg leading-5 text-gray-700 font-open-sans tracking-wide hover:text-red focus:outline-none transition duration-150 ease-in-out break-words"-->
          <!--                >Update Display Name</a-->
          <!--              >-->
          <!--            </router-link>-->
          <!--          </div>-->

          <div v-if="isAdmin" class="px-4 py-2">
            <router-link to="/topicApproval" class="flex items-center">
              <vectric-admin-tool></vectric-admin-tool>
              <a
                v-if="isAdmin"
                href="#"
                class="block  text-lg leading-5 text-gray-700 font-open-sans  tracking-wide
            hover:text-red focus:outline-none  transition duration-150 ease-in-out"
                >Topic Approval
              </a>
            </router-link>
          </div>

          <div v-if="isAdmin" class="px-4 py-2">
            <router-link to="/updateDisplayName" class="flex items-center">
              <vectric-admin-tool></vectric-admin-tool>
              <a
                href="#"
                class="block text-lg leading-5 text-gray-700 font-open-sans tracking-wide hover:text-red focus:outline-none transition duration-150 ease-in-out break-words"
                >Update Display Name</a
              >
            </router-link>
          </div>

          <div v-if="isAdmin" class="px-4 py-2">
            <router-link to="/generateLoginLink" class="flex items-center">
              <vectric-admin-tool></vectric-admin-tool>
              <a
                v-if="isAdmin"
                href="#"
                class="block  text-lg leading-5 text-gray-700 font-open-sans tracking-wide
            hover:text-red focus:outline-none  transition duration-150 ease-in-out"
                >Generate Login Link
              </a>
            </router-link>
          </div>
        </div>
        <div class="py-1 rounded-md bg-white shadow-xs" v-else>
          <router-link to="/login">
            <a
              href="#"
              class="block px-4 py-2 text-lg leading-5 text-gray-700 tracking-wide
            hover:text-red focus:outline-none  transition duration-150 ease-in-out"
              >Sign In</a
            >
          </router-link>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import Avatar from "./Avatar";
import { auth } from "../utils/firebase.js";
import { mapGetters } from "vuex";
import VectricAdminTool from "./VectricAdminTool";

export default {
  name: "ProfileMenu",
  data() {
    return {
      showDropdown: false
    };
  },
  components: {
    VectricAdminTool,
    Avatar
  },
  methods: {
    hideMenu(e) {
      if (!this.$el.contains(e.target)) {
        this.showDropdown = false;
      }
    },
    signOut() {
      auth
        .signOut()
        .then()
        .catch(console.error("There was a problem signing you out"));
    }
  },
  mounted() {
    document.addEventListener("click", this.hideMenu);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.hideMenu);
  },
  computed: {
    ...mapGetters(["loggedIn", "isAdmin"]),
    email() {
      if (this.$store.state.user.loggedIn) {
        return this.$store.state.user.email;
      }
      return "";
    },
    userDisplay() {
      if (this.$store.state.user.loggedIn) {
        return this.$store.state.user.displayName;
      }
      return "";
    }
  }
};
</script>

<style scoped></style>
